
import Plyr from 'plyr';


// Featured video
jQuery(function($){

	// Change "{}" to your options:
	// https://github.com/sampotts/plyr/#options
	const player = new Plyr('#player', {
		title: '',
		// controls: [] // Empty array to hide all controls
		// controls: ['progress', 'current-time', 'play'] 
		// controls: ['play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'] // Define the controls you want
	});

	// Expose player so it can be used from the console
	window.player = player;

	$(".play-button-wrap").click(function() {
		// console.log('clicked 5');
        if (player.playing) {
			player.pause();
		} else {
			player.play();
		}
	});

	// Show controls when video is playing
	player.on('play', () => {
		$(".section-video").addClass('js-is-playing');
	});

	// Hide controls when video is paused or ended
	player.on('pause', () => {
		$(".section-video").removeClass('js-is-playing');
	});

	player.on('ended', () => {
		$(".section-video").removeClass('js-is-playing');
		setTimeout(() => {
			player.restart();
		}, 10);
	});

});